/**
 * Duração de ligação em dois formatos, porque os dois destinos são diferentes.
 *
 * Espelha `common/utils/duracao.util.ts` do whiz-server: a frase da timeline é
 * montada nos DOIS lados (o servidor congela uma cópia em `conteudo` para
 * exportação e relatório; o front remonta para poder mudar redação sem
 * migration), e duas redações divergentes seriam duas verdades sobre a mesma
 * ligação.
 */

/**
 * Texto FALADO ("1m 20s"), para frase lida junto de outras palavras.
 *
 * `null` para ausência de duração — e não "0s": ligação que ninguém atendeu não
 * tem duração, e é isso que faz a frase dizer "perdida" em vez de "0s".
 */
export function formatarDuracaoFalada(segundos: number | null | undefined): string | null {
    if (segundos === null || segundos === undefined || !Number.isFinite(segundos) || segundos < 0) return null;

    const total = Math.round(segundos);
    if (total < 60) return `${total}s`;

    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const resto = total % 60;

    // Acima de uma hora o segundo é ruído: ninguém lê "1h 02m 07s".
    if (horas > 0) return `${horas}h ${String(minutos).padStart(2, '0')}m`;

    return resto === 0 ? `${minutos}m` : `${minutos}m ${resto}s`;
}

/**
 * Cronômetro ("01:20", "1:02:07"), para o card da ligação em curso.
 *
 * Largura estável de propósito: o número muda a cada segundo na tela, e no
 * formato falado ele mudaria de LARGURA junto ("59s" → "1m") fazendo o card
 * pular. A hora só aparece quando existe.
 */
export function formatarCronometro(segundos: number | null | undefined): string {
    const total = Math.max(0, Math.floor(Number.isFinite(segundos as number) ? (segundos as number) : 0));
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const resto = total % 60;

    const mm = String(minutos).padStart(2, '0');
    const ss = String(resto).padStart(2, '0');
    return horas > 0 ? `${horas}:${mm}:${ss}` : `${mm}:${ss}`;
}
